import React from 'react'
import { priceNotation, numberNotation } from '../../../utils/safe'
import Trans from '../../atoms/Trans/Trans'

const DettagliProdottoListino = ({ prezzi, prezziTransfer, refTableSchedaProdotto }) => {
  return (
    <div className="dettagli-prodotto__listino">
      {Object.entries(prezzi).map((item, i) => (
        <div className="dettagli-prodotto__listino__block" key={i}>
          <p className="dettagli-prodotto__listino__block-title">{item[1][0].nome}</p>
          <div className="dettagli-prodotto__listino__table">
            <div className="dettagli-prodotto__listino__col">
              <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                <Trans chiave="Quantità fina a" />
              </p>
              <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                <Trans chiave="Prezzo personalizz." />
              </p>
            </div>

            {item[1].map((obj, j) => {
              return (
                <div key={j} className="dettagli-prodotto__listino__col">
                  <div className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--quantity">
                    {obj.fino_a}
                  </div>
                  <div className="dettagli-prodotto__listino__cell">
                    {priceNotation(obj.prezzo_personalizzazione, 3)} €
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      ))}

      {prezziTransfer && (
        <div className="dettagli-prodotto__listino__block">
          <p className="dettagli-prodotto__listino__block-title">
            <Trans chiave="Transfer" />
          </p>
          <div className="dettagli-prodotto__listino__table">
            <div className="dettagli-prodotto__listino__col">
              <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                <Trans chiave="Quantità fino a" />
              </p>
              <p className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--title">
                <Trans chiave="Prezzo personalizz." />
              </p>
            </div>
            {prezziTransfer.map((obj) => {
              return (
                <div className="dettagli-prodotto__listino__col">
                  <div className="dettagli-prodotto__listino__cell dettagli-prodotto__listino__cell--quantity">
                    {numberNotation(obj.qta)}
                  </div>
                  <div className="dettagli-prodotto__listino__cell">
                    {priceNotation(obj.prezzo, 3)} €
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default DettagliProdottoListino
